import api from "../../../api/axios";

export const fetchCompanyFinanceReceipts = (companyId, params) =>
  api
    .get(`/companies/${companyId}/finance/receipts/`, { params })
    .then((res) => res.data);

export const createCompanyFinanceReceipt = (companyId, body) =>
  api
    .post(`/companies/${companyId}/finance/receipts/`, body)
    .then((res) => res.data);

export const fetchCompanyFinanceReceipt = (companyId, receiptId) =>
  api
    .get(`/companies/${companyId}/finance/receipts/${receiptId}/`)
    .then((res) => res.data);

export const fetchCompanyFinanceObligations = (companyId, params) =>
  api
    .get(`/companies/${companyId}/finance/obligations/`, { params })
    .then((res) => res.data);

export const createCompanyFinanceObligation = (companyId, body) =>
  api
    .post(`/companies/${companyId}/finance/obligations/`, body)
    .then((res) => res.data);

export const fetchCompanyFinanceObligation = (companyId, obligationId) =>
  api
    .get(`/companies/${companyId}/finance/obligations/${obligationId}/`)
    .then((res) => res.data);

export const fetchCompanyFinanceAllocations = (companyId, params) =>
  api
    .get(`/companies/${companyId}/finance/allocations/`, { params })
    .then((res) => res.data);

export const createCompanyFinanceAllocation = (companyId, body) =>
  api
    .post(`/companies/${companyId}/finance/allocations/`, body)
    .then((res) => res.data);

export const fetchCompanyFinanceSettlements = (companyId, params) =>
  api
    .get(`/companies/${companyId}/finance/settlements/`, { params })
    .then((res) => res.data);

export const createCompanyFinanceSettlement = (companyId, body) =>
  api
    .post(`/companies/${companyId}/finance/settlements/`, body)
    .then((res) => res.data);

export const fetchCompanyFinanceCorrections = (companyId, params) =>
  api
    .get(`/companies/${companyId}/finance/corrections/`, { params })
    .then((res) => res.data);

export const createCompanyFinanceCorrection = (companyId, body) =>
  api
    .post(`/companies/${companyId}/finance/corrections/`, body)
    .then((res) => res.data);

export const fetchOwnCompanyRemuneration = (companyId) =>
  api
    .get(`/companies/${companyId}/my-remuneration/`)
    .then((res) => res.data);
